<mat-card>

  <mat-card-content>
    <div class="flex flex-col w-full">
      <div class="flex flex-row">
        <button mat-raised-button (click)="newVisit()" style="background: #7ABDF3;">
          <mat-icon>add</mat-icon> Add Initial Site Visit
        </button>
      </div>

      <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort fxFlex="100" #TableSort="matSort"
        class="mat-elevation-z8">

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="padding-left: 10px;"></th>
          <td mat-cell *matCellDef="let visit" style="padding-left: 10px;align-items: center;">
            <div class="flex flex-row">
              <a title="Edit Initial Site Visit" (click)="editInitialSiteVisit(visit)"
                *ngIf="complaintId != null && complaintId > 0 && complaintId==visit.complaintId ">
                <mat-icon>edit</mat-icon></a>

              <span *ngIf="complaintId != null && complaintId > 0 && isAdmin">
                <span>&nbsp;</span>
                <a (click)="removeInitialSiteVisit(visit)">
                  <mat-icon style="color:red;">delete</mat-icon></a>
              </span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="complaintId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint ID</th>
          <td mat-cell *matCellDef="let visit">
            <span *ngIf="complaintId != null && complaintId > 0">{{visit.complaintId}}</span>
            <a *ngIf="complaintId == null || complaintId == 0" (click)="gotoComplaint(visit)">
              {{visit.complaintId}}</a>
          </td>
        </ng-container>
        <ng-container matColumnDef="visitDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Visit Date</th>
          <td mat-cell *matCellDef="let visit">
            <div class="flex flex-row">
              <mat-icon *ngIf="visit.visitDate == null || visit.visitDate == ''" style="color: red;">warning</mat-icon>
              <span>{{visit.visitDate}}</span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="visitConducted">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Conducted</th>
          <td mat-cell *matCellDef="let visit">
            <span *ngIf="visit.visitConducted != null && visit.visitConducted == 1">Yes</span>
            <span *ngIf="visit.visitConducted == null || visit.visitConducted == 0" style="color: red;">No</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="violationFound">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Violation Found</th>
          <td mat-cell *matCellDef="let visit">
            <span *ngIf="visit.violationFound != null && visit.violationFound == 1" style="color: red;">Yes</span>
            <span *ngIf="visit.violationFound == 0">No &mdash; Complaint Resolved</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="siteVisitDetails">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Site Visit Details</th>
          <td mat-cell *matCellDef="let visit">
            <span *ngIf="visit.visitConductedReason == 1">Site Visit Denied (Forwarded to OHA)</span>
            <span *ngIf="visit.visitConductedReason == 2">Failure to develop Remediation Plan (Forwarded to OHA)</span>
            <span *ngIf="visit.visitConductedReason == 3">Other - Explain in Comments</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="siteVisitNotes">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Site Visit Notes</th>
          <td mat-cell *matCellDef="let visit">
            <div *ngIf="!visit.allowEditing"><span>{{visit.notes}}</span></div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>
      </table>
    </div>
  </mat-card-content>

</mat-card>